export class DeleteSolutionMinorVersionRecordError extends Error {
}